import { useRouter } from 'next/router';
import { useState } from 'react';
import styled from 'styled-components';
import { useMutation } from 'react-query';
import Button, { ButtonVariant, ButtonSize } from '@/components/Common/Button';
import { StyledForm } from '@/components/Common/Form';
import TextField from '@/components/Common/TextField';
import Alert from '@/components/Common/Modal/Alert';
import TitleMask from '@/components/Common/Layout/TitleMask';
import { fetchFind } from '@/api/auth';

const ButtonWrapper = styled.div`
  margin-top: 48px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

function FindPassword() {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [email, setEmail] = useState('');

  const find = useMutation(fetchFind);

  const handleEmail = e => {
    setEmail(e.target.value);
  };

  const handleOnModalClose = () => {
    setIsOpen(false);
    router.push('/login');
  };
  const handleOnModalOpen = () => {
    find.mutate(email, {
      onSuccess: () => {
        setIsOpen(true);
      },
      onError: () => {
        window.alert('오류');
      },
    });
  };
  const BUTTON_LIST = [
    {
      label: '취소',
      onClick: handleOnModalClose,
    },
    {
      label: '확인',
      onClick: handleOnModalClose,
    },
  ];
  return (
    <div>
      {isOpen && (
        <Alert
          visible={isOpen}
          title="임시 비밀번호 발송"
          onClick={handleOnModalClose}
        >
          <p>
            등록하신 이메일로 임시 비밀번호를
            <br />
            발송하였습니다.
          </p>
          <br />
          <p>
            임시비밀번호로 로그인 후<br /> 마이노트 메뉴에서
            <br />
            비밀번호를 변경해 주세요.
          </p>
        </Alert>
      )}
      <TitleMask title="비밀번호 찾기">
        <StyledForm>
          <TextField
            id="id"
            label="아이디"
            placeholder="아이디@이메일을 입력해주세요"
            name="email"
            type="text"
            value={email}
            onChange={handleEmail}
          >
            <Button
              label="임시 비밀번호 전송"
              variant={ButtonVariant.White}
              size={ButtonSize.Small}
              onClick={handleOnModalOpen}
            />
          </TextField>
          <ButtonWrapper>
            {BUTTON_LIST.map(({ label, onClick }, index) => {
              const isEven = index % 2 === 0;
              const variant = isEven
                ? ButtonVariant.White
                : ButtonVariant.Default;

              return (
                <Button
                  key={label}
                  label={label}
                  size={ButtonSize.Big}
                  variant={variant}
                  onClick={onClick}
                />
              );
            })}
          </ButtonWrapper>
        </StyledForm>
      </TitleMask>
    </div>
  );
}

export default FindPassword;
